<template>
  <div class="twui-signup">
    <div class="twui-signup-header">
      <img src="static/dev/images/logo_reg.png" />
      <span>天闻ECO云开放平台</span>
    </div>
    <div class="twui-signup-body" style="{ 'min-height':minHeight }">
      <h2>{{ roleName }}注册</h2>
      <div class="twui-bgbox">
        <div class="twui-astable xinfotip">
          <div class="twui-astable-col xinfotip-imgbox">
            <i class="twui-ico xregtip"></i>
          </div>
          <div class="twui-astable-col xinfotip-body">以下是{{ roleName }}注册表单，每项都是必须输入项，提交注册后，将有工作人员对您的信息进行审核，审核通过后将会通过邮件通知您。</div>
        </div>
      </div>
      <el-form class="twui-signup-form">
        <el-form-item label="所选地区:" label-width="7em">
          <el-cascader placeholder="请选择地址" :options="options" filterable style="width:100%;"></el-cascader>
        </el-form-item>
        <el-form-item label="单位名称:" v-show="roleName=='区域管理员'" label-width="7em">
          <el-input auto-complete="off"></el-input>
        </el-form-item>
        <div class="twui-signup-school" v-show="roleName=='学校管理员'">
          <el-form-item label="学校名称:" label-width="7em">
            <el-input auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="学校类型:" label-width="7em">
            <div>
              <el-checkbox>小学</el-checkbox>
              <el-radio class="twui-xspace-md">5年制</el-radio>
              <el-radio class="twui-xspace-md">6年制</el-radio>
            </div>
            <div>
              <el-checkbox>小学</el-checkbox>
              <el-radio class="twui-xspace-md">3年制</el-radio>
              <el-radio class="twui-xspace-md">4年制</el-radio>
            </div>
            <div>
              <el-checkbox>高中</el-checkbox>
              <el-radio class="twui-xspace-md">3年制</el-radio>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="联系人姓名:" label-width="7em">
          <el-input auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录邮箱:" label-width="7em">
          <el-input auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" label-width="7em">
          <el-input auto-complete="off" style="width:160px;"></el-input>
          <el-input auto-complete="off" class="twui-xspace-md" style="width:90px;"></el-input>
          <a class="twui-xlink">&nbsp;&nbsp;获取验证码</a>
        </el-form-item>
        <el-form-item label="登录密码:" label-width="7em">
          <el-input auto-complete="off" placeholder="密码至少包含字母、数字、符号中两种，6-20个字符"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" label-width="7em">
          <el-input auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系地址:" label-width="7em">
          <el-input auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" label-width="7em">
          <el-input auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:7em;">
          <button class="twui-btn xmain xxlarge">同意协议并提交</button>
        </el-form-item>
        <el-form-item style="margin-left:7em;">
          <div class="twui-midline">
            <a class="twui-midline-body twui-xlink">《天闻服务协议》</a>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div id="particles-js" style="position:fixed; z-index:-1; top:0; left:0; width:100%; height:100%;"></div>
    <tw-footer></tw-footer>
  </div>
</template>
<script>
  import '@/static/plugs/particles.min.js'

  export default {
    name: 'signup',
    data () {
      return {
        minHeight: 0,
        roleName: '学校管理员',
        options: [
          {
            value: 'hunan',
            label: '湖南',
            children: [
              {
                value: 'cs',
                label: '长沙',
                children: [
                  {
                    value: 'yuhuaqu',
                    label: '雨花区'
                  }
                ]
              }
            ]
          },
          {
            value: 'zj',
            label: '浙江',
            children: [
              {
                value: 'hz',
                label: '杭州',
                children: [
                  {
                    value: 'jgq',
                    label: '江干区'
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    created: function () {
      this.minHeight = window.innerHeight - 160 + 'px'
    },
    mounted: function () {
      window.particlesJS.load('particles-js', '/static/dev/plugs/particles.json', function () {
        console.log('callback - particles-js config loaded')
      })
    }
  }
</script>



// WEBPACK FOOTER //
// signup.vue?93f528f2